import React from 'react';
import { cx } from './utils';

export default function EmptyState({ title, description, className, children }) {
  return (
    <div className={cx('empty', className)}>
      {title && <div className="empty__title">{title}</div>}
      {description && <div className="empty__desc">{description}</div>}
      {children}
    </div>
  );
}
